import '../Dialog.css';
import './AircraftDialog.css';

import React, {Component} from 'react';

import Units    from '../../tools/Units';
import Services from '../../tools/Services';

import {Line}       from 'react-chartjs-2';
import {URL_S3}     from '../../tools/Constants';

import {Box, Drawer, Table, TableHead, TableBody, TableRow, TableCell, List, ListItem, ListItemIcon, ListItemText, Icon, IconButton, Divider} from '@material-ui/core'

import CloseIcon     from '@material-ui/icons/Close';
import ExploreIcon   from '@material-ui/icons/Explore';

export default class AircraftDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            arrival:'',
            departure:'',
            schedule:[],
            open: false,
            openType :true,
            openGraph :false,
        }
    }

    getImage(img, aircraft) {
        let url = URL_S3 + 'aircraft/img/';

        // Default
        if (img === undefined){
            if(aircraft.aircraft_type === 'R') return;
            return false;
        }

        // Image exists
        return url + img;
    }
    
    openTab = (e) => {
        let property = e.currentTarget.name;
        this.setState({[property]:!this.state[property]})
    }

    openGraph = ()=> {
        this.props.openGraphFromDialog();
    }
    
    handleGraphClose = () => {
        this.setState({openGraph:false});
    }
    
    render() {
    let { open, data,options, onClose, openGraph, points, pusher, squishContent } = this.props;
    let { mfr, model, registration, alt, s, b, lat, lon, date_position, img, aircraft_type } = this.props.aircraft;


    return (
        <Box mb={pusher} id="2">
            <Drawer containerStyle={{height: 'auto'}} id="AircraftDialog" transitionDuration={300} variant="persistent" className={squishContent} open={open}>
                
                <div  className="top" id="1">
                    <IconButton className="closeIcon" onClick={onClose}>
                        <CloseIcon className="dialogIcon" edge="end" ></CloseIcon>
                    </IconButton>
                <div className="img">
                    <img src={this.getImage(img, this.props.aircraft)} alt=""></img>
                    </div>
                </div>
    
                <div className="dialogTitle">
                    <h2>{registration}</h2>
                    <h5>{`${mfr} ${model}`}</h5>
                </div>
                
                <List>

                    {/* Speedometer */}

                    <ListItem className="dialogListTitle" >
                        <ListItemIcon  > 
                            <Icon className="mdi mdi-speedometer dialogIcon"></Icon>
                        </ListItemIcon>
                        
                        <ListItemText onClick={this.openTab}>Speed and Altitude</ListItemText >
                    </ListItem>  
                    
                    <Divider></Divider>
                    
                    {/* GRAPH */}
                 
                            {data && this.props.aircraft.inflight &&
                            <div className="graphClick">
                                <Icon onClick={this.openGraph} className="mdi mdi-arrow-top-right-bottom-left dialogIcon"></Icon>
                            </div>
                        }   
                    
                    {data && <Line className="graph" data={points} options={options} type="line" ></Line>}
                    <Divider></Divider>
                    
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell>Ground Speed</TableCell>
                                <TableCell>Altitude</TableCell>
                                <TableCell>Heading</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell>{Units.knotsToKilos(s)}kt</TableCell>
                                <TableCell>{Units.metersToFeet(alt)}ft</TableCell>
                                <TableCell>{b}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                
                    {/* Location */}
                    <ListItem className="dialogListTitle" >
                        <ListItemIcon className="ListIcon" > 
                            <ExploreIcon className="dialogIcon"></ExploreIcon>
                        </ListItemIcon>
                        <ListItemText >Location</ListItemText>
                    </ListItem>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Latitude</TableCell>
                                <TableCell>Longitude</TableCell>
                                <TableCell>Last Position</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow hover>
                                {lat && <TableCell  >{lat.toFixed(6)}</TableCell>}
                                {lon && <TableCell >{lon.toFixed(6)}</TableCell>}
                                <TableCell>{Services.getTimeFromNow(date_position)}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>

                    {/* Schedule */}
                    {/* <ListItem className="dialogListTitle" >
                        <ListItemIcon > 
                            <DateRangeIcon className="dialogIcon"></DateRangeIcon>
                        </ListItemIcon>
                        <ListItemText >Schedule</ListItemText>
                
                    </ListItem>
                    <Table>
                        <TableHead>
                            <TableCell>Departures</TableCell>
                            <TableCell>Arrivals</TableCell>
                        </TableHead>
                        <TableBody>
                        {
                            this.state.schedule.length > 0 ? this.state.schedule.map((a) => {
                                return (
                                    <TableRow>
                                        <TableCell align='left'>{Services.dateConverter(a.timestamp_begin, 'hh:mm')}</TableCell>
                                        <TableCell align='left'>{Services.dateConverter(a.timestamp_end,   'hh:mm')}</TableCell>
                                    </TableRow>
                                        );
                                    }) : (
                                    <TableRow className='noInformation'>
                                        <TableCell colSpan="2">Not available</TableCell>
                                    </TableRow>
                                    )
                        }
                        </TableBody>
                    </Table> */}
                </List>
            </Drawer>
        </Box>
        );
    };
};

